export default __webpack_public_path__ + "static/media/students.52b2255a.svg";